import React from 'react'
import PersonAvatar from '../PersonAvatar'
import TrashButton from 'app/components/buttons/TrashButton'
import ApproveButton from 'app/components/buttons/ApproveButton'
import { useIsRootAdmin } from 'commons/useUserProfile'
import Assets from 'app/configs/assetConfigs'
import _ from 'lodash'
import * as R from 'ramda'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  postIcon: {
    width: '17px',
    margin: '5px',
  },
}))

export const withFirstColumn = (obj) => ({
  accessor: '',
  sortable: false,
  width: 96,
  ...obj,
})

const PersonAvatarCell = _.memoize((row) => (
  <PersonAvatar
    className="mx-8"
    placeHolder={row.original.avatarCharacters}
    subId={row.original.id}
    alt={row.original.name}
    src={
      R.isNil(R.path(['original', 'crmInfo', 'avatar'], row))
        ? R.path(['original', 'avatar'], row)
        : R.path(['original', 'crmInfo', 'avatar'], row)
    }
  />
))

const TeamMemberPersonAvatarCell = _.memoize((row) => (
  <PersonAvatar
    placeHolder={row.original.avatarCharacters}
    subId={row.original.id}
    alt={row.original.firstName}
    src={row.original.avatar}
    className="mx-8"
  />
))

export const withAvatarColumn = (accessor = 'avatar') => ({
  Header: () => null,
  accessor: accessor,
  Cell: PersonAvatarCell,
  width: 64,
  sortable: false,
})

export const withTeamMemberAvatarColumn = (accessor = 'avatar') => ({
  Header: () => null,
  accessor: accessor,
  Cell: TeamMemberPersonAvatarCell,
  width: 64,
  sortable: false,
})

export const withBeaconImageColumn = (accessor = 'image') => ({
  Header: () => null,
  accessor: accessor,
  Cell: (row) => (
    <img
      className="mx-8 w-1/2"
      alt={row.original.name}
      src={
        Assets.manageBeacon.colors[row.original.color] ||
        Assets.manageBeacon.colors.default
      }
    />
  ),
  width: 64,
  sortable: false,
})

export const withDeleteColumn = (
  handlerDeleteOne,
  show = true,
  shouldHideDeleteButton = () => false,
  disabled = false,
  width = 128,
) => ({
  Header: '',
  width,
  sortable: false,
  show,
  Cell: (cell) => {
    const isRootAdmin = useIsRootAdmin()

    if (shouldHideDeleteButton(cell) || isRootAdmin(cell.original.id)) {
      return <div className="flex w-full p-24"></div>
    }
    return (
      <div className="flex w-full justify-center items-center">
        <TrashButton
          disabled={disabled}
          onClick={(ev) => {
            ev.stopPropagation()
            handlerDeleteOne(cell)
          }}
        />
      </div>
    )
  },
})

export const withTopicsDeleteColumn = (
  handlerDeleteOne,
  show = true,
  shouldHideDeleteButton = () => false,
  disabled = false,
  width = 128,
) => ({
  Header: '',
  width,
  sortable: false,
  show,
  Cell: (cell) => {
    return (
      <div className="flex w-full justify-center items-center">
        <TrashButton
          disabled={disabled}
          onClick={(ev) => {
            ev.stopPropagation()
            handlerDeleteOne(cell)
          }}
        />
      </div>
    )
  },
})

export const withActionColumn = (
  handlerDeleteOne,
  handlerCreateOne,
  show = true,
  shouldHideDeleteButton = () => false,
  disabled = false,
  width = 128,
) => ({
  Header: '',
  width,
  sortable: false,
  show,
  Cell: (cell) => {
    const isRootAdmin = useIsRootAdmin()
    const classes = useStyles()
    if (shouldHideDeleteButton(cell) || isRootAdmin(cell.original.id)) {
      return null
    }

    return (
      <div className="flex w-full justify-end items-center">
        {cell.original.subscribersCount > 0 && (
          <IconButton
            onClick={(ev) => {
              ev.stopPropagation()
              handlerCreateOne(cell)
            }}
          >
            <img
              className={classes.postIcon}
              src={Assets.postIcon.blue}
              alt="PostIcon"
            />
          </IconButton>
        )}
        <TrashButton
          disabled={disabled}
          onClick={(ev) => {
            ev.stopPropagation()
            handlerDeleteOne(cell)
          }}
        />
      </div>
    )
  },
})

export const withStatusDialog = (
  handlerDeleteOne,
  handleApprove,
  show = true,
  shouldHideDeleteButton = () => false,
  disabled = false,
) => ({
  Header: '',
  width: 128,
  sortable: false,
  show,
  Cell: (cell) => {
    const isRootAdmin = useIsRootAdmin()
    const isPending = 2
    const INVITE_STATUS = cell.original.lastInvitationStatus

    if (shouldHideDeleteButton(cell) || isRootAdmin(cell.original.id)) {
      return null
    }

    return (
      <div
        className={
          INVITE_STATUS === isPending
            ? 'flex w-full justify-end items-center'
            : 'flex w-full justify-end items-center'
        }
      >
        <ApproveButton
          hidden={INVITE_STATUS !== isPending}
          onClick={(ev) => {
            ev.stopPropagation()
            handleApprove(cell)
          }}
        />
        <TrashButton
          disabled={disabled}
          onClick={(ev) => {
            ev.stopPropagation()
            handlerDeleteOne(cell)
          }}
        />
      </div>
    )
  },
})
